module.exports = __webpack_public_path__ + "static/img/function2.fa3e095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/function2.svg
// module id = y3TW
// module chunks = 11